export default __webpack_public_path__ + "static/disparities-mobile-36642b1957f35a62df88ef8802d9df89.png";